"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _zoomedImage = _interopRequireDefault(require("./zoomedImage"));

var _styled = require("./styled");

/**
 * ZoomableImage renders an image that is zoomed in when clicked
 */
var ZoomableImage = function ZoomableImage(_ref) {
  var className = _ref.className,
      style = _ref.style,
      src = _ref.src,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height;
  var ref = (0, _react.useRef)();
  var imageRect = (0, _react.useRef)({});

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var open = function open() {
    imageRect.current = ref.current.getBoundingClientRect();
    setIsOpen(true);
  };

  var close = function close() {
    setIsOpen(false);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styled.StyledImage, {
    className: className,
    style: style,
    src: src,
    alt: alt,
    width: width,
    height: height,
    ref: ref,
    isOpen: isOpen,
    onClick: open
  }), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: isOpen
  }, /*#__PURE__*/_react["default"].createElement(_zoomedImage["default"], {
    src: src,
    alt: alt,
    close: close,
    originalRect: imageRect.current
  })));
};

ZoomableImage.propTypes = {
  /** The class name of the root element. */
  className: _propTypes["default"].string,

  /** It is an object with custom style applied to the root element. */
  style: _propTypes["default"].object,

  /** The image URL. */
  src: _propTypes["default"].string,

  /** Defines an alternative text description of the image. */
  alt: _propTypes["default"].string,

  /** The intrinsic width of the image in pixels. Must be an integer without a unit. */
  width: _propTypes["default"].number,

  /** The intrinsic height of the image, in pixels. Must be an integer without a unit. */
  height: _propTypes["default"].number
};
ZoomableImage.defaultProps = {
  className: undefined,
  style: undefined,
  src: '',
  alt: '',
  width: undefined,
  height: undefined
};
var _default = ZoomableImage;
exports["default"] = _default;